import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearReissueCardState,
    selectCardError,
    selectCardOrderPostSuccess,
} from 'lib/slices/cardsSlice';
import useTranslate from 'lib/languages/useTranslate';
import { useForm, usePrevious } from 'lib/utils';
import StatusCardModal from '../presentational/StatusCardModal';
import { hideModal, showModal } from 'actions/modal';
import { DISMISS_MODAL } from 'constants/shared/modalTypes';
import { CardReissueReason } from 'lib/type';
import { useReissueCardMutation } from 'lib/services';

const StatusCardModalContainer = ({ cardSerial, account }) => {
    const dispatch = useDispatch();
    const translate = useTranslate('cards.orderReplacementModal');
    const error = useSelector(selectCardError);
    const prevPostError = usePrevious(error);
    const reissueCardIsPostSuccess = useSelector(selectCardOrderPostSuccess);
    const prevPostSuccess = usePrevious(reissueCardIsPostSuccess);
    const [reissueCardMutation] = useReissueCardMutation();

    const options = [
        { value: CardReissueReason.LOST, label: translate('lost') },
        { value: CardReissueReason.DAMAGED, label: translate('damaged') },
        { value: CardReissueReason.STOLEN, label: translate('stolen') },
    ];

    const [form, handleChange] = useForm({
        status: '',
    });

    const handleSubmit = () => {
        reissueCardMutation({ cardSerial, prevStatus: form.status });
    };

    const handleClose = () => {
        dispatch(clearReissueCardState());
        dispatch(hideModal());
    };

    useEffect(() => {
        if (reissueCardIsPostSuccess && !prevPostSuccess) {
            dispatch(hideModal());
        }
    }, [reissueCardIsPostSuccess, prevPostSuccess, dispatch]);

    useEffect(() => {
        const handleDeleteError = () => {
            if (error) {
                dispatch(
                    showModal({
                        type: DISMISS_MODAL,
                        props: {
                            title: translate('titleText'),
                            message: translate('error'),
                            handleCancel: () => {
                                dispatch(hideModal());
                            },
                        },
                    }),
                );
            }
        };
        if (!prevPostError && error) {
            dispatch(hideModal());
            handleDeleteError();
        }
    }, [error, prevPostError, translate, dispatch]);

    return (
        <div className="status-card-modal">
            <StatusCardModal
                {...form}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                handleClose={handleClose}
                options={options}
            />
        </div>
    );
};

export default StatusCardModalContainer;
